//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        current: {
            type: Number,
            required: true,
        },
        total: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            radius: 30,
        };
    },
    computed: {
        dashOffset() {
            return ((100 - (this.current / this.total) * 100) / 100) * Math.PI * (this.radius * 2);
        },
    },
};
